import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import { classNames } from '../../../helpers/classnames.js';

var AnimatedProgress = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    // начальные значения анимации, будут изменяться для каждой следующей пары "персиков" для создания эффекта размытого следа
    var pairStyleSettings = {
        animationDelay: 0,
        opacity: 1,
        zIndex: 20
    };
    // шаг с которым будут изменяться стили каждого следующего шага
    var stepChanges = {
        animationDelay: 5,
        opacity: 1.18,
        zIndex: 1
    };
    // количество пар "персиков" создающее визуальный эффект размытого следа
    var pairsAmount = 20;
    // данные стилей для каждой пары
    var pairsData = [];
    for (var pairs = 0; pairs <= pairsAmount; pairs++) {
        // наполняем массив, клонируя объект настроек
        pairsData.push(__assign({}, pairStyleSettings));
        // изменяем текущие настройки на один шаг
        pairStyleSettings.animationDelay += stepChanges.animationDelay;
        pairStyleSettings.opacity /= stepChanges.opacity;
        // pairStyleSettings.zIndex -= stepChanges.zIndex;
    }
    return (React__default.createElement("span", __assign({ "data-testid": "AnimatedProgress", className: classNames('dsb-progress-animated', className) }, props), pairsData.map(function (data, i) { return (React__default.createElement("div", { key: i, className: "dsb-progress-animated__pair", style: { animationDelay: data.animationDelay + 'ms', opacity: data.opacity, zIndex: data.zIndex } },
        React__default.createElement("span", { className: "dsb-progress-animated__circle" }),
        React__default.createElement("span", { className: "dsb-progress-animated__circle" }))); })));
};

export { AnimatedProgress };
